/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { OrderItem1 } from './order-item1';
import { SapOrderContainer } from './sap-order-container';
import { SapOrderPartner1 } from './sap-order-partner1';

/**
 * 
 * @export
 * @interface SalesOrderDetail
 */
export interface SalesOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    Id?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    OrderStatus?: SalesOrderDetailOrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    OriginalEta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    UpdatedEta?: string | null;
    /**
     * 
     * @type {Array<OrderItem1>}
     * @memberof SalesOrderDetail
     */
    OrderItems?: Array<OrderItem1>;
    /**
     * 
     * @type {Array<SapOrderPartner1>}
     * @memberof SalesOrderDetail
     */
    OrderPartners?: Array<SapOrderPartner1>;
    /**
     * 
     * @type {Array<SapOrderContainer>}
     * @memberof SalesOrderDetail
     */
    OrderContainers?: Array<SapOrderContainer>;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    OrderNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    OrderType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    SoldToParty?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    ReqDlvDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    Currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    PurchOrder?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    PurchOrderDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    CustReference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    CreatedOn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    CreatedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    ChangedOn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    City?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    DeliveryNo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    DeliveryDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    BillOfLading?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    MeansOfTransportation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    MeansOfTransportationDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    IncoTerms1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetail
     */
    IncoTerms2?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOrderDetail
     */
    CreatedInPortal?: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SalesOrderDetailOrderStatusEnum {
    AwsFailed = 'AWS_FAILED',
    AwsCreated = 'AWS_CREATED',
    SapCreated = 'SAP_CREATED',
    SapProcessing = 'SAP_PROCESSING',
    SapProcessingPart = 'SAP_PROCESSING_PART',
    SapShipped = 'SAP_SHIPPED',
    SapShippedPart = 'SAP_SHIPPED_PART',
    SapCancelled = 'SAP_CANCELLED',
    SapUnknown = 'SAP_UNKNOWN',
    Delivered = 'DELIVERED'
}



